import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ViewEncapsulation } from '@angular/compiler/src/core';
import { Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { JsonPages } from '../_models/JsonPages';
import { Pages } from '../_models/Pages';
import { PagesMenus } from '../_models/PagesMenus';

@Component({
  selector: 'app-feature',
  templateUrl: './feature.component.html',
})
export class FeatureComponent {
  public Pages: Pages;
  public PagesMenus: PagesMenus[];
  public url: string;
  public html: string;
  public http: HttpClient;
  isExpanded = false;

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  constructor(private router: Router,http: HttpClient, private formBuilder: FormBuilder, private route: ActivatedRoute, private modalService: NgbModal, @Inject('BASE_URL') baseUrl: string) {
    this.url = baseUrl;
    this.http = http;
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };

  }

  ngOnInit() {
  
    var id = this.route.snapshot.paramMap.get('id');
    var id2 = this.route.snapshot.paramMap.get('id2');

    if (id == null) {
      id = "FR";
    }

    if (id2 == null) {
      id2 = "home";
    }
    const jsonPages: JsonPages = {
      Lang: id,
      Code: id2,
      Pages: null,
      PagesMenus: []
    };
    
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    this.http.post<JsonPages>(this.url + 'api/pages/read', JSON.stringify(jsonPages), { headers: headers, params: null }).subscribe(result => {
      this.Pages = result.Pages;
      this.PagesMenus = result.PagesMenus;
    },
      error => {

      });


  }
}
